import useRefreshToken from 'hooks/useRefreshToken';
import useInitSocket, { SocketContext } from 'hooks/useSocket';
import { Route, Routes } from 'react-router-dom';
import NotFoundPage from './NotFound';
import RefreshPage from './RefreshPage';
import ShopWrapperLayout from './ShopWrapperLayout';
import LoginPage from './auth/pages/Login';
import OwnerDashboard from './auth/pages/OwnerDashboard';
import TurnPage from './turn/pages';

const RootScreens = () => {
  const { shield } = useRefreshToken();
  const socketContext = useInitSocket();

  return (
    <SocketContext.Provider value={socketContext}>
      <>
        <Routes>
          <Route path="refresh" element={<RefreshPage />} />
          <Route path="store/:shop_id" element={shield(ShopWrapperLayout)}>
            <Route path="" element={<TurnPage />} />
          </Route>
          <Route path="/sign-in" element={<LoginPage />} />
          <Route path="/owner/dashboard" element={shield(OwnerDashboard)} />
          <Route path="/" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    </SocketContext.Provider>
  );
};

export default RootScreens;
